import React, { useState } from 'react';
import Modal from './Modal';
import Header from './Header';
import MobileHeader from './MobileHeader';
import FrontPage from './FrontPage';
import PopularCastings from './PopularCastings';
import SuccessStories from '../SuccessStories';
import WhatWeOffer from '../pages/WhatWeOffer';
import FlourishTalentsClub from './FlourishTalentsClub';
import FlourishMedia from './FlourishMedia';
import ContactoRegister from './ContactoRegister';
import Footer from './Footer';
import MobileBottomNav from './MobileBottomNav';

export default function Main() {
  // Global iframe-modal (used by other sections)
  const [modalOpen, setModalOpen] = useState(false);
  const [modalUrl, setModalUrl]     = useState('');
  const openModal  = (url) => { setModalUrl(url); setModalOpen(true);  };
  const closeModal = ()    => { setModalOpen(false); setModalUrl(''); };

  return (
    <div id="main">
      <div className="homepage">
        <Header />
        <MobileHeader />
        <FrontPage />
        <PopularCastings />
      </div>

      {/* Rest of page */}
      <SuccessStories />
      <WhatWeOffer />
      <FlourishTalentsClub />
      <FlourishMedia />
      <ContactoRegister />
      <Footer />
      <MobileBottomNav />

      {/* Global Form Modal */}
      <Modal isOpen={modalOpen} onClose={closeModal}>
        <iframe
          src={modalUrl}
          title="Embedded Form"
          width="100%"
          height="100%"
          style={{ border: 'none' }}
        >
          Loading…
        </iframe>
      </Modal>
    </div>
  );
}
